import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { _ } from "src/services";
import { ConfigInit, ModalsAction } from "src/store";
import { Gift, History, Package } from "../../svg";

export const ProfileNoPurchase: React.FC = () => {

    const config: ConfigInit = useSelector((state: any) => state.ConfigState);
    const dispatch = useDispatch();
    const openGift = () => dispatch(ModalsAction.showGift());
    const subsUrl = `/subscription/${config.config?.appSetting?.singleSubscriptionId || ""}`;

    return (
        <div className="no-package d-flex flex-column jsutify-content-center align-items-center py-4 px-4">
            <div className="d-flex flex-column py-4">
                <div className="large-icon">
                    <History size={70} />
                </div>
            </div>
            <div className="d-flex flex-column py-4" style={{ minWidth: 280 }}>
                <div className="text-center">{_("youHaveNoPurchases")}</div>
                <div className="d-flex justify-content-between pt-3 pb-4 mb-4 buttons">
                    <Link to={subsUrl} className="btn btn-packages">
                        <Package size={16} />
                        <span>{_("buyPackage")}</span>
                    </Link>
                    <button className="btn btn-reverse" onClick={openGift}>
                        <Gift size={16} />
                        <span>{_("addGiftCode")}</span>
                    </button>
                </div>
            </div>
        </div>
    );

};